module.exports = __webpack_public_path__ + "static/media/Exlamation Mark.a707b10c.png";